/*
  Soovie shipping protection
  - Adds the Shipping Protection product (qty 1) whenever the cart has any other product.
  - If the customer removes it, it stays removed for that cart (remembered in a hidden cart attribute).
  - Removing it never touches other items. If every other item is removed, protection is removed too.
*/
(function () {
  var VARIANT_ID = Number(window.SOOVIE_PROTECTION_VARIANT_ID);
  if (!VARIANT_ID || window.__soovieProtectionLoaded) return;
  window.__soovieProtectionLoaded = true;

  var DECLINED_ATTR = '_protection_removed';
  var CART_PATHS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
  var origFetch = window.fetch.bind(window);
  var lastHadProtection = null;
  var busy = false;
  var queued = false;
  var timer = null;

  function urlOf(input) {
    if (typeof input === 'string') return input;
    return (input && input.url) || '';
  }

  function isCartMutation(url) {
    var path = String(url || '').split('?')[0];
    if (path.slice(-3) === '.js') path = path.slice(0, -3);
    return CART_PATHS.some(function (p) { return path.slice(-p.length) === p; });
  }

  function onCartPage() {
    var p = window.location.pathname;
    if (p.slice(-1) === '/') p = p.slice(0, -1);
    return p.slice(-5) === '/cart';
  }

  // Watch every cart change the theme makes (add to cart, quantity buttons, remove, upsells).
  window.fetch = function (input, init) {
    var request = origFetch(input, init);
    if (isCartMutation(urlOf(input))) {
      request.then(function () { schedule(); }, function () {});
    }
    return request;
  };

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 400);
  }

  function getCart() {
    return origFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function post(path, body) {
    return origFetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(path + ' returned ' + r.status);
      return r.json();
    });
  }

  function setDeclined(value) {
    var attrs = {};
    attrs[DECLINED_ATTR] = value;
    return post('/cart/update.js', { attributes: attrs });
  }

  function setProtectionQty(qty) {
    var updates = {};
    updates[VARIANT_ID] = qty;
    return post('/cart/update.js', { updates: updates });
  }

  async function sync() {
    if (busy) { queued = true; return; }
    busy = true;
    try {
      var cart = await getCart();
      var protectionQty = 0;
      var otherItems = 0;
      cart.items.forEach(function (item) {
        if (item.variant_id === VARIANT_ID) protectionQty += item.quantity;
        else otherItems += 1;
      });
      var declined = !!(cart.attributes && cart.attributes[DECLINED_ATTR] === 'yes');
      var changed = false;

      if (otherItems === 0) {
        // Cart is empty or only has protection: clear it and reset the choice for next time.
        if (protectionQty > 0) { await setProtectionQty(0); changed = true; }
        if (declined) await setDeclined('');
        lastHadProtection = false;
      } else if (protectionQty > 0) {
        // Keep it at exactly one.
        if (protectionQty !== 1) { await setProtectionQty(1); changed = true; }
        lastHadProtection = true;
      } else {
        // Products in cart, no protection.
        if (lastHadProtection === true && !declined) {
          // The customer just removed it: respect that for this cart.
          await setDeclined('yes');
          declined = true;
        }
        if (!declined) {
          await post('/cart/add.js', { items: [{ id: VARIANT_ID, quantity: 1 }] });
          changed = true;
          lastHadProtection = true;
        } else {
          lastHadProtection = false;
        }
      }

      if (changed) await refreshUI();
    } catch (e) {
      console.warn('Shipping protection sync failed', e);
    } finally {
      busy = false;
      if (queued) { queued = false; schedule(); }
    }
  }

  async function refreshUI() {
    if (onCartPage()) {
      window.location.reload();
      return;
    }
    var res = await origFetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble');
    if (!res.ok) return;
    var data = await res.json();
    var parser = new DOMParser();

    var drawer = document.querySelector('cart-drawer');
    if (drawer && data['cart-drawer']) {
      var doc = parser.parseFromString(data['cart-drawer'], 'text/html');
      var newInner = doc.querySelector('.drawer__inner');
      var inner = drawer.querySelector('.drawer__inner');
      if (newInner && inner) inner.innerHTML = newInner.innerHTML;
      var newDrawer = doc.querySelector('cart-drawer');
      if (newDrawer) drawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
      if (typeof drawer.initializeUpsellButtons === 'function') drawer.initializeUpsellButtons();
      if (typeof drawer.initializeVariantSelectors === 'function') drawer.initializeVariantSelectors();
    }

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && data['cart-icon-bubble']) {
      var bdoc = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
      var src = bdoc.querySelector('.shopify-section');
      if (src) bubble.innerHTML = src.innerHTML;
    }
  }

  // Covers carts filled by a full page load (e.g. buy-now links, non-AJAX forms).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();